/**
 * Rune Glyphs
 *
 * 10 Elder Futhark unicode characters scattered across the viewport.
 * Barely visible (0.07 max opacity) — subliminal ancient presence.
 * CSS handles positioning and animation in challenge.css.
 */

import React from 'react';

const RUNES = [
  '\u16A0', // fehu
  '\u16A2', // uruz
  '\u16A6', // thurisaz
  '\u16A8', // ansuz
  '\u16B1', // raido
  '\u16B2', // kenaz
  '\u16B7', // gebo
  '\u16B9', // wunjo
  '\u16BA', // hagalaz
  '\u16BE', // naudiz
];

export const RuneGlyphs: React.FC = () => {
  return (
    <div className="rune-layer">
      {RUNES.map((rune, i) => (
        <span key={i} className="rune-glyph">{rune}</span>
      ))}
    </div>
  );
};
